import React, { Component } from "react"
import PropTypes from "prop-types"

import { bindActionCreators } from "redux"
import { connect } from "react-redux"

import { LinkContainer } from "react-router-bootstrap"
import {
  Grid, PageHeader, Table, Button, Glyphicon,
  //FormGroup, ControlLabel, FormControl
} from "react-bootstrap"

import { Map } from "immutable"
import numeral from "numeral"
import moment from "moment-timezone"
import "moment/locale/id"

import * as actionCreators from "../actions"
import { ButtonAdd, getRecords } from "./Common"

class Expenses extends Component {
  static propTypes = {
    expenses: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired
  }

  state = {}

  handleDelete = e => {
    e.preventDefault()
    
    const { id } = e.target
    if (window.confirm("Are you sure you want to delete this item?")) {
      this.props.actions.deleteExpense(id)
    }
  }

  render() {
    return (
      <Grid>
        <PageHeader>
          Daftar Expense
          <span className="pull-right"><ButtonAdd to="/expense/new" /></span>
        </PageHeader>

        <Table responsive fill striped>
          <thead>
            <tr>
              {/* <th className="text-center">&nbsp;</th> */}
              <th className="text-center">Tanggal</th>
              <th className="text-center">Keterangan</th>
              <th className="text-center">Biaya</th>
              <th className="text-center">&nbsp;</th>
            </tr>
          </thead>
          <tbody>
            { getRecords(this.props.expenses).map(o => (
              <tr key={o.get("uuid")}>
                <td>
                  {moment(o.get("expenseDate")).format("LL")}
                  <Button className="pull-right" bsSize="xsmall" bsStyle="danger" id={o.get("uuid")} onClick={this.handleDelete}>
                    <Glyphicon glyph="trash" id={o.get("uuid")} />
                  </Button> 
                </td>
                <td>
                  {
                    o.get("description") && o.get("description").length > 30 ?
                    o.get("description").substr(0, 27) + "..." :
                    o.get("description") 
                  }
                </td>
                <td className="text-right">{numeral(o.get("amount")).format("0,0")}</td>
                <td className="text-center" style={{ verticalAlign: "middle" }}>
                  <LinkContainer to={`/expense/${o.get("uuid")}`}>
                    <Button bsSize="xsmall">Detail</Button>
                  </LinkContainer>
                </td>
              </tr>
            )) }
          </tbody>
          <tfoot>
            <tr>
              <td colSpan="100">&nbsp;</td>
            </tr>
          </tfoot>
        </Table>
      </Grid>
    )
  }
}

const mapStateToProps = state => ({
  expenses: state.get("expenses") || Map()
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actionCreators, dispatch)
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Expenses)



// WEBPACK FOOTER //
// ./src/components/Expenses.js